const ACTIONS = {
  SHOW_MODAL: 'Modal:Show',
  HIDE_MODAL: 'Modal:Hide',
};

export default ACTIONS;

export const buyNow = () => ({ type: ACTIONS.SHOW_MODAL, modal: 'buy-now' });
export const hideModal = () => ({ type: ACTIONS.HIDE_MODAL });



// WEBPACK FOOTER //
// ./src/actions.js